import React from 'react';
import { TbShoppingBagExclamation } from 'react-icons/tb';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useNavigate } from 'react-router-dom';
import { useStoreHook } from '../../../Hooks/StoreHook';
import { useTranslation } from 'react-i18next';

interface CardEmptyProps {
  onCloseCart?: CallableFunction;
}

const CardEmpty = ({
  onCloseCart,
}: CardEmptyProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const {getLinkToHome} = useStoreHook();

  const handleClick = () => {
    navigate(getLinkToHome())
    onCloseCart?.(false)
  }

  return (
    <section className='flex flex-col w-full h-full items-center justify-center text-center'>
        <TbShoppingBagExclamation size={50} className="mb-3 fadeInIcon" />
        <div className='text-xl font-bold'>{t('cart_empty.title')}</div>
        <p className='leading-5 px-2'>{t('cart_empty.message')}</p>

        <ButtonPrimary
            onClick={handleClick}
            className="mt-6">
            {t('cart_empty.button_start')}
        </ButtonPrimary>
    </section>
  )
}

export default CardEmpty;